/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createPagedResultOfSentEmailDtoFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type PagedResultOfSentEmailDto } from '../../../models/index.js';
// @ts-ignore
import { type WithEmailItemRequestBuilder, WithEmailItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/emails/sent
 */
export interface SentRequestBuilder extends BaseRequestBuilder<SentRequestBuilder> {
    /**
     * Gets an item from the MomentumAPI.api.emails.sent.item collection
     * @param emailId The email's id, from the deliveries list.
     * @returns {WithEmailItemRequestBuilder}
     */
     byEmailId(emailId: string) : WithEmailItemRequestBuilder;
    /**
     * Lists the emails the organization has sent, one row per recipient, newest first, with each email's latest delivery status and its open and click counts. Filter by kind, record, latest status, recipient and send time. Delivery statuses arrive after the send, so a recent email can still read as sent.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PagedResultOfSentEmailDto>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<SentRequestBuilderGetQueryParameters> | undefined) : Promise<PagedResultOfSentEmailDto | undefined>;
    /**
     * Lists the emails the organization has sent, one row per recipient, newest first, with each email's latest delivery status and its open and click counts. Filter by kind, record, latest status, recipient and send time. Delivery statuses arrive after the send, so a recent email can still read as sent.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<SentRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Lists the emails the organization has sent, one row per recipient, newest first, with each email's latest delivery status and its open and click counts. Filter by kind, record, latest status, recipient and send time. Delivery statuses arrive after the send, so a recent email can still read as sent.
 */
export interface SentRequestBuilderGetQueryParameters {
    /**
     * Only emails about this record (an order or invoice id, for example).
     */
    entityId?: string;
    /**
     * Only emails sent at or after this time.
     */
    from?: Date;
    /**
     * Only emails about this kind of record: order, invoice, tearsheet, cart-share, cart-review, company-docs, access-request, api-access, user, sales-rep or organization-signup.
     */
    kind?: string;
    /**
     * The page to return, starting at 1.
     */
    pageNumber?: number;
    /**
     * Emails per page, at most 100.
     */
    pageSize?: number;
    /**
     * Only emails sent to this exact address (case-insensitive).
     */
    recipient?: string;
    /**
     * Only emails whose latest status is this: scheduled, sent, delivery_delayed, delivered, opened, clicked, bounced, complained, failed or suppressed.
     */
    status?: string;
    /**
     * Only emails sent before this time.
     */
    to?: Date;
}
/**
 * Uri template for the request builder.
 */
export const SentRequestBuilderUriTemplate = "{+baseurl}/api/emails/sent?pageNumber={pageNumber}&pageSize={pageSize}{&entityId*,from*,kind*,recipient*,status*,to*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const SentRequestBuilderNavigationMetadata: Record<Exclude<keyof SentRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byEmailId: {
        requestsMetadata: WithEmailItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["emailId"],
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const SentRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: SentRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPagedResultOfSentEmailDtoFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
